import { useFetch, CachePolicies } from 'use-http';
import { routes } from './routes';

export interface FeatureFlag {
  name: string;
  description: string;
  enabled: boolean;
}

export interface FeatureFlagsResponse {
  flags: FeatureFlag[];
}

export function useFeatureFlagsApi() {
  const { get, put, loading, error } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: true,
    },
  }));

  const fetchFlags = (): Promise<FeatureFlagsResponse> =>
    get(routes.featureFlags);

  const toggleFlagStatus = (flagName: string): Promise<FeatureFlagsResponse> =>
    put(routes.toggleFeatureFlag, { flags: [{ name: flagName }] });

  return {
    fetchFlags,
    toggleFlagStatus,
    loading,
    error,
  };
}

export interface AccountSort {
  option: AccountSortOption;
  direction: AccountSortDirection;
}

export interface ConnectedStore {
  storeAlias: string;
  domain?: string;
  runningExperiences?: number;
  draftExperiences?: number;
  pausedExperiences?: number;
  archivedExperiences?: number;
  abTestsExperiences?: number;
  isAppEmbedEnabled?: boolean;
  isUninstalled?: boolean;
  trialDaysRemaining?: number;
  storeStatus?: string;
}

export enum AccountSortOption {
  __NA = `__NA`,
  BY_CREATION_DATE = `BY_CREATION_DATE`,
  BY_ORDERS = `BY_ORDERS`,
  BY_ORDERS_ACTIVE = `BY_ORDERS_ACTIVE`,
}

export enum AccountSortDirection {
  ___NA = 1,
  ASC = 1,
  DESC = -1,
}

export const sortByCreationDateAsc: AccountSort = {
  option: AccountSortOption.BY_CREATION_DATE,
  direction: AccountSortDirection.ASC,
};

export const sortByCreationDateDesc: AccountSort = {
  option: AccountSortOption.BY_CREATION_DATE,
  direction: AccountSortDirection.DESC,
};

export const sortByOrdersAsc: AccountSort = {
  option: AccountSortOption.BY_ORDERS,
  direction: AccountSortDirection.ASC,
};

export const sortByOrdersDesc: AccountSort = {
  option: AccountSortOption.BY_ORDERS,
  direction: AccountSortDirection.DESC,
};

export const sortByOrdersActiveDesc: AccountSort = {
  option: AccountSortOption.BY_ORDERS_ACTIVE,
  direction: AccountSortDirection.DESC,
};

export const sortByOrdersActiveAsc: AccountSort = {
  option: AccountSortOption.BY_ORDERS_ACTIVE,
  direction: AccountSortDirection.ASC,
};
